import { TextButton } from '@creditornot/cb-button';
import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { MenuMetaContext } from 'modules/menu/MenuMetaContext';
import MenuEditorCollectionList from 'modules/menu/components/MenuEditorCollectionList';
import { useAllOptionsDurationViewTracking } from 'modules/menu/hooks/telemetryHooks';
import useMenuEditorLists from 'modules/menu/hooks/useMenuEditorLists';

import OptionModal from './OptionModal';
import OptionSidePanel from './OptionSidePanel';
import { MenuPermissionsContext } from '../../components/MenuPermissionsContext';

const AddButton = styled(TextButton).attrs({ variant: 'brand' })``;

const Options = () => {
  const intl = useIntl();

  const { menuId } = useContext(MenuMetaContext);
  const menuPermissions = useContext(MenuPermissionsContext);

  const {
    menuEditorList,
    activeOption,
    searchFilter,
    setSearchFilter,
    newOptionModalProps,
    setActiveOptionId,
    handleOptionCopy,
  } = useMenuEditorLists('all-options');
  useAllOptionsDurationViewTracking();
  return (
    <>
      <MenuEditorCollectionList
        title={intl.formatMessage({ id: 'menu.allOptions' })}
        description={intl.formatMessage({ id: 'menu.allOptionsDescription' })}
        search={searchFilter}
        onSearch={setSearchFilter}
        headerRight={
          menuPermissions.contentEdit && (
            <AddButton onClick={() => setActiveOptionId('new-option')}>
              <FormattedMessage id="menu.addOption" />
            </AddButton>
          )
        }
        itemData={{
          menuId,
          list: menuEditorList,
          activeOptionId: activeOption?.id,
          onOptionClick: optionId => setActiveOptionId(optionId !== activeOption?.id ? optionId : undefined),
          onOptionCopy: handleOptionCopy,
        }}
      >
        {!!activeOption && (
          <OptionSidePanel optionState={activeOption} menuId={menuId} onClose={() => setActiveOptionId(undefined)} />
        )}
      </MenuEditorCollectionList>
      <OptionModal {...newOptionModalProps} />
    </>
  );
};

export default Options;
